import { render, staticRenderFns } from "./PauseOrderReferenceButton.vue?vue&type=template&id=49bb2b5a&"
import script from "./PauseOrderReferenceButton.vue?vue&type=script&lang=js&"
export * from "./PauseOrderReferenceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports